import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './i18n/config'; // Initialize i18n
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

// Set initial HTML lang attribute based on detected language
const detectedLang = localStorage.getItem('i18nextLng') || navigator.language.split('-')[0];
const supportedLangs = ['en', 'es', 'fr'];
const lang = supportedLangs.includes(detectedLang) ? detectedLang : 'en';
document.documentElement.lang = lang;

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 